<template>
  <div>
    <div class="mt-3">Solicitação Nº {{ idNotificacao }}</div>
    <div class="row mt-3">
      <div class="col-sm-12">
        <b-button
          class="border shadow-sm mr-2"
          variant="light"
          v-b-tooltip.hover="'Voltar'"
          @click="voltar()"
        >
          <font-awesome-icon icon="chevron-left" size="lg" fixed-width />
          <span class="align-middle">Voltar</span>
        </b-button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsCorrecaoCadastral"
          :orderby="sortBy"
          :items="lstCorrecaoCadastral"
          responsive
          :porPage="itemPorPage"
          :titlePage="titlePage"
          :mostrarQuantidade="false"
          :titlePDF="titlePage"
        ></fccTable>
      </div>
    </div>
    <fccFiltraCorrecaoCadastralVue
      ref="xfiltraCorrecaoCadastral"
      :controlePage="controlePage"
      @liberarStatus="liberarStatus"
      :baseUrlPublicacao="baseUrlPublicacao"
      :idNotificacao="idNotificacao"
      :tpPublicacao="tipopublicacao"
    />
    <fccCorrecaoFormVue
      :controlePage="controlePage"
      v-if="tipopublicacao >= 2"
      :baseUrlPublicacao="baseUrlPublicacao"
      :idNotificacao="idNotificacao"
      :tpPublicacao="tipopublicacao"
    />
    <fccCorrecaoControle
      ref="correcaoControle"
      v-show="tipopublicacao > 0"
      :idNotificacao="idNotificacao"
      :spi="controlePage.spi"
      @controleCorrecao="controleCorrecao"
    />
  </div>
</template>
<script>
import axios from 'axios'
import fccFiltraCorrecaoCadastralVue from './fccFiltraCorrecaoCadastral.vue'
import fccCorrecaoFormVue from './fccCorrecaoForm.vue'
import fccCorrecaoControle from './fccCorrecaoControle.vue'

export default {
  data() {
    return {
      titlePage: 'Publicações',
      sortBy: 'nome',
      itemPorPage: '1000',
      visualizaExportar: false,
      visualizaLiberar: false,
      liberarForm: false,
      lstControle: [],
      lstCorrecaoCadastral: [],
      tppublicacao: 0,
      permissao: {},
      fieldsCorrecaoCadastral: [
        { key: 'respondente', label: 'Respondente', sortable: true },
        { key: 'datadaresposta', label: 'Data da Resposta', sortable: true },
        { key: 'aguardando', label: 'Aguardando', sortable: true },
        { key: 'statusfinal', label: 'Status' }
      ]
    }
  },
  components: { fccFiltraCorrecaoCadastralVue, fccCorrecaoFormVue, fccCorrecaoControle },
  methods: {
    voltar() {
      this.$emit('zerarSolicitacao', 0)
    },
    controleCorrecao(tipo) {
      /*
        1-Nova Solicitação de Correção Cadastral
        2-Dados Exportados Aguardando Publicação
        3-Correção Cadastral Publicada
        4-Prazo da Correção Cadastral Finalizado
        5-Alterações Importadas
      */
      this.$refs['xfiltraCorrecaoCadastral'].listaControleCargos()

      this.tppublicacao = tipo
    },
    visualizaFinalizar(status) {
      this.visualizaExportar = status
    },
    exportaVagas(status) {
      this.visualizaLiberar = status
    },
    liberarStatus() {
      this.$refs['correcaoControle'].listarControleStatus()
    },
    listarVagas() {
      axios
        .get(
          this.baseUrlPublicacao +
            'PublicacaoCorrecaoCadastral/CorrecaoCadastralControles/' +
            this.controlePage.spi +
            '/' +
            this.idNotificacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstCorrecaoCadastral = response.data
          if (this.lstCorrecaoCadastral.length > 0) {
            this.lstCorrecaoCadastral.forEach(function (data) {
              data['statusfinal'] = data['status']
              delete data['status']
            })
          }
        })
        .catch(this.setErrorSystem)
    }
  },
  props: {
    controlePage: Object,
    idNotificacao: Number,
    baseUrlPublicacao: String
  },
  computed: {
    tipopublicacao() {
      return this.tppublicacao
    }
  },
  mounted() {
    this.permissao = this.permissaoPage.find((lista) => lista.objpermcodigo === 'X')
    this.listarVagas()
  }
}
</script>
